// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeWheelPicker_pickerWrapper__Gmpm3 {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(160deg, rgba(45, 25, 70, 0.95), rgba(20, 10, 40, 0.95));
  border-radius: 20px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  width: 280px;
  min-height: 280px;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.TimeWheelPicker_wrapper__YYhaV {
  display: flex;
  justify-content: center;
  position: relative;
  gap: 16px;
  overflow: hidden;
  height: 200px;
}

.TimeWheelPicker_wheel__qxl0h {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 60px;
  height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-snap-type: y mandatory;
  scrollbar-width: none;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  touch-action: pan-y;
  position: relative;
}

.TimeWheelPicker_wheel__qxl0h::-webkit-scrollbar {
  display: none;
}

.TimeWheelPicker_wheel__qxl0h li {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: center;
  transition: color 0.2s, font-size 0.2s, font-weight 0.2s;
}

.TimeWheelPicker_wheel__qxl0h li.TimeWheelPicker_active__Sjwn4 {
  color: #fff;
  font-weight: 600;
  font-size: 20px;
}

.TimeWheelPicker_highlight__Oxxa9 {
  position: absolute;
  top: 80px;
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  pointer-events: none;
  z-index: 2;
}

.TimeWheelPicker_colon__Vd4Ab {
  position: absolute;
  top: 80px; /* Центр по вертикали (2 * 40px) */
  left: 50%;
  transform: translateX(-50%);
  font-size: 20px;
  color: #fff;
  z-index: 3;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.TimeWheelPicker_fadeTop__qyhq-,
.TimeWheelPicker_fadeBottom__BFnk5 {
  position: absolute;
  width: 100%;
  height: 60px;
  pointer-events: none;
  z-index: 1;
}

.TimeWheelPicker_fadeBottom__BFnk5 {
  bottom: 0;
}

.TimeWheelPicker_confirmBtn__sDLfZ {
  margin-top: 16px;
  width: 140px;
}
`, "",{"version":3,"sources":["webpack://./src/components/TimeWheelPicker/TimeWheelPicker.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mFAAmF;EACnF,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,kCAAkC;EAC7C,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".pickerWrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: linear-gradient(160deg, rgba(45, 25, 70, 0.95), rgba(20, 10, 40, 0.95));\n  border-radius: 20px;\n  padding: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  width: 280px;\n  min-height: 280px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.wrapper {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  gap: 16px;\n  overflow: hidden;\n  height: 200px;\n}\n\n.wheel {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 60px;\n  height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scroll-snap-type: y mandatory;\n  scrollbar-width: none;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 18px;\n  touch-action: pan-y;\n  position: relative;\n}\n\n.wheel::-webkit-scrollbar {\n  display: none;\n}\n\n.wheel li {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  scroll-snap-align: center;\n  transition: color 0.2s, font-size 0.2s, font-weight 0.2s;\n}\n\n.wheel li.active {\n  color: #fff;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.highlight {\n  position: absolute;\n  top: 80px;\n  width: 100%;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.colon {\n  position: absolute;\n  top: 80px; /* Центр по вертикали (2 * 40px) */\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 20px;\n  color: #fff;\n  z-index: 3;\n  pointer-events: none;\n  user-select: none;\n}\n\n.fadeTop,\n.fadeBottom {\n  position: absolute;\n  width: 100%;\n  height: 60px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.fadeBottom {\n  bottom: 0;\n}\n\n.confirmBtn {\n  margin-top: 16px;\n  width: 140px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pickerWrapper": `TimeWheelPicker_pickerWrapper__Gmpm3`,
	"wrapper": `TimeWheelPicker_wrapper__YYhaV`,
	"wheel": `TimeWheelPicker_wheel__qxl0h`,
	"active": `TimeWheelPicker_active__Sjwn4`,
	"highlight": `TimeWheelPicker_highlight__Oxxa9`,
	"colon": `TimeWheelPicker_colon__Vd4Ab`,
	"fadeTop": `TimeWheelPicker_fadeTop__qyhq-`,
	"fadeBottom": `TimeWheelPicker_fadeBottom__BFnk5`,
	"confirmBtn": `TimeWheelPicker_confirmBtn__sDLfZ`
};
export default ___CSS_LOADER_EXPORT___;
